<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="gauze">
	<!-- Generator: Adobe Illustrator 20.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 97.4 75.6" style="enable-background:new 0 0 97.4 75.6;" xml:space="preserve">
		<style type="text/css">
			.st0 {
				fill: #FFC939;
			}
			
			.st1 {
				fill: #178A00;
			}
			
			.st2 {
				fill: #939393;
			}
			
			.st3 {
				fill: #DC2E28;
			}
			
			.st4 {
				fill: #141414;
			}
			
			.st5 {
				fill: #F20808;
			}
			
			.st6 {
				fill: #EA940A;
			}
			
			.st7 {
				fill: #07D329;
			}
			
			.st8 {
				font-family: 'lato, arial, ArialMT';
			}
			
			.st9 {
				font-size: 12px;
			}
		</style>
		<g>
			<g>

				<path class="st0" d="M30.9,25.2c10.8-7.1,24.8-7.1,35.7,0L77.1,9.9C60-2,37.4-2,20.2,9.9L30.9,25.2z" />


				<path class="st1" d="M81.6,12.3L71,27.7c4.5,4.2,7.7,9.7,9.3,15.7l17.2-5C95,28.3,89.5,19.2,81.6,12.3z" />
				<path class="st2" d="M45.8,36.5V41v5c0,0.3,0.2,0.5,0.5,0.5h5.4c0.3,0,0.5-0.2,0.5-0.5l0,0c0.1,0,0.3,0.1,0.5,0.1s0.4,0,0.6-0.1
			c0.4-0.2,0.6-0.4,0.8-0.8s0.1-0.8,0-1.1l-0.8-1.9c0,0-0.3-0.7-0.3-1.4v-0.6l0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-1.6
			c0-0.1,0-0.2-0.1-0.2l-0.8-0.6v-1c0-0.3-0.2-0.5-0.5-0.5h-5.4C46.1,35.9,45.8,36.2,45.8,36.5z M52.3,38.1l0.3,0.2l-0.3,0.2V38.1z
			 M52.3,40.2L52.3,40.2l0.1,0.5c0,0.8,0.3,1.6,0.3,1.6l0.8,1.9c0.1,0.2,0.1,0.4,0,0.7c-0.1,0.2-0.2,0.4-0.5,0.5s-0.6,0.1-0.8-0.1
			v-5.1C52.2,40.2,52.3,40.2,52.3,40.2z M46.5,36.8h5.1v3.1h-5.1V36.8z" />
				<path class="st3" d="M15.8,12.3C7.9,19.2,2.4,28.3,0,38.5l17.2,5c1.5-6,4.7-11.5,9.3-15.7L15.8,12.3z" />
				<path *ngIf="fuelLevelType===2" class="st4" d="M52.8,50.9l-4-20.1l-0.1-0.3l-0.1,0.3l-4,20.1c-0.8,2.7,0.4,5.6,2.7,6.5s4.7-0.5,5.5-3.2
			C53.1,53.1,53.1,51.9,52.8,50.9z" />
				<g>
					<path class="st3" d="M24.5,39.2c0.1,0.1,0.2,0.1,0.3,0.1c0.3,0,0.4-0.1,0.5-0.3c0.2-0.3,0-0.6-0.3-0.8l-2-1
				c-0.3-0.2-0.7,0-0.8,0.2c-0.2,0.3,0,0.6,0.3,0.8L24.5,39.2z" />
					<path class="st3" d="M25.4,33.6c-0.3-0.2-0.7-0.2-0.8,0.2c-0.2,0.2-0.2,0.6,0.2,0.8l1.9,1.3c0.1,0.1,0.3,0.1,0.3,0.1
				c0.2,0,0.3-0.1,0.5-0.2c0.2-0.2,0.2-0.6-0.2-0.8L25.4,33.6z" />
					<path class="st0" d="M35.3,29.3c0.1,0,0.2,0,0.3-0.1c0.3-0.2,0.4-0.5,0.3-0.8l-1-1.9c-0.2-0.3-0.5-0.4-0.8-0.2
				c-0.3,0.2-0.4,0.5-0.3,0.8l1,1.9C34.9,29.2,35.1,29.3,35.3,29.3z" />
					<path class="st0" d="M40,26.9c0.1,0,0.1,0,0.2,0c0.3-0.1,0.5-0.4,0.4-0.7l-0.7-2.1c-0.1-0.3-0.4-0.5-0.8-0.4
				c-0.3,0.1-0.5,0.4-0.4,0.7l0.7,2.1C39.6,26.7,39.8,26.9,40,26.9z" />
					<path class="st0" d="M44.9,25.9L44.9,25.9c0.4-0.1,0.7-0.3,0.6-0.6l-0.3-2.2c-0.1-0.3-0.3-0.6-0.7-0.5c-0.3,0.1-0.6,0.3-0.5,0.6
				l0.3,2.2C44.4,25.8,44.7,25.9,44.9,25.9z" />
					<path class="st0" d="M52.8,22.6c-0.3-0.1-0.7,0.2-0.7,0.5l-0.3,2.2c-0.1,0.3,0.2,0.6,0.5,0.6h0.1c0.3,0,0.6-0.2,0.6-0.5l0.3-2.2
				C53.4,23,53.1,22.7,52.8,22.6z" />
					<path class="st0" d="M57.2,23.7c-0.3-0.1-0.7,0.1-0.8,0.4l-0.7,2c-0.1,0.3,0.1,0.6,0.4,0.7c0.1,0,0.1,0,0.2,0
				c0.3,0,0.5-0.2,0.6-0.4l0.7-2.1C57.7,24.1,57.6,23.8,57.2,23.7z" />
					<path class="st1" d="M68.9,30.4c-0.3-0.2-0.6-0.2-0.8,0l-1.6,1.5c-0.3,0.2-0.3,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2
				s0.3-0.1,0.4-0.2l1.6-1.5C69.1,31,69.1,30.6,68.9,30.4z" />
					<path class="st1" d="M71.8,33.8c-0.2-0.2-0.6-0.3-0.8-0.2l-1.9,1.3c-0.3,0.2-0.3,0.6-0.2,0.8c0.1,0.2,0.3,0.2,0.5,0.2
				c0.1,0,0.3,0,0.3-0.1l1.9-1.3C72,34.3,72.1,34,71.8,33.8z" />
					<path class="st1" d="M71.2,39c0.1,0.2,0.3,0.3,0.5,0.3c0.1,0,0.2,0,0.3-0.1l2-1c0.3-0.2,0.4-0.5,0.3-0.8
				c-0.2-0.3-0.5-0.4-0.8-0.2l-2,1C71.1,38.3,71,38.6,71.2,39z" />
					<path class="st3" d="M25.5,42.2l-4.3-1.3c-0.5-0.2-1,0.1-1.2,0.6c-0.2,0.5,0.1,1,0.6,1.1l4.3,1.3c0.1,0,0.2,0.1,0.3,0.1
				c0.4,0,0.8-0.2,0.8-0.6C26.3,42.8,26,42.3,25.5,42.2z" />
					<path class="st0" d="M49.1,27.1v-4.2c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v4.2c0,0.5,0.4,0.9,0.9,0.9S49.1,27.6,49.1,27.1z"
					/>
					<path class="st0" d="M64,25.5c-0.4-0.3-1-0.2-1.3,0.2l-2.6,3.4c-0.3,0.4-0.2,1,0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.2
				c0.3,0,0.6-0.2,0.8-0.3l2.6-3.4C64.5,26.3,64.4,25.8,64,25.5z" />
					<path class="st1" d="M75.1,40.8l-4.3,1.3c-0.5,0.2-0.8,0.6-0.6,1.1c0.1,0.4,0.5,0.6,0.8,0.6c0.1,0,0.2,0,0.3-0.1l4.3-1.3
				c0.5-0.2,0.8-0.6,0.6-1.1C76.1,40.9,75.6,40.6,75.1,40.8z" />
					<path class="st3" d="M32.2,33l-3.1-3c-0.4-0.3-0.9-0.4-1.3-0.1c-0.4,0.4-0.4,0.9-0.1,1.2l3.1,3c0.1,0.1,0.1,0.1,0.2,0.2
				c0.4,0.2,0.8,0.1,1-0.1C32.6,34,32.6,33.5,32.2,33z" />
					<path class="st0" d="M36.7,28.7l-2.6-3.5c-0.3-0.4-0.8-0.5-1.3-0.2c-0.4,0.3-0.5,0.8-0.3,1.2l2.6,3.5c0.1,0.1,0.1,0.2,0.2,0.2
				c0.3,0.2,0.8,0.2,1,0C36.9,29.7,37,29.2,36.7,28.7z" />
					<path class="st3" d="M75.4,19.1" />
				</g>
				<path *ngIf="fuelLevelType===3" class="st4" d="M52.6,54.9l14.2-14.8l0.2-0.2L66.7,40l-18.8,8.2c-2.6,0.9-4.3,3.5-3.8,5.9c0.5,2.4,3.1,3.6,5.7,2.7
			C50.9,56.5,51.9,55.8,52.6,54.9z" />
				<path *ngIf="fuelLevelType===1" class="st4" d="M49.8,47.8l-19.3-7.1l-0.3-0.1l0.2,0.2l15,14c1.9,2.1,5,2.6,6.9,1.1c2-1.4,2.1-4.3,0.2-6.4
			C51.9,48.7,50.9,48.1,49.8,47.8z" />
			</g>
		</g>
	</svg>
</div>